<template>
    <div class="el-btn-icon">
        <i v-if="icon" :class="[icon ? `lnr-${icon}` : '']"></i>
    </div>
</template>

<script>
/**
 * The purpose of this component is to look like an icon button without actualy being an button
 */
export default {
    name: 'mead-fake-button-icon',
    props: {
        /**
         * Name of the icon (rendered via `lnr-{icon}`) shown inside the fake button.
         */
        icon: {type: [String, Boolean], default: () => false},
    },
};
</script>